import React from 'react';
import styled from 'styled-components';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    $width?: string;
    $minWidth?: string;
    $type?: string;
    $height?: string;
    $fontSize?: string;
    $lineHeight?: string;
}

export const BaseButton = styled.button<ButtonProps>`
    width: ${({$width}) => $width || 'fit-content'};
    min-width: ${({$minWidth}) => $minWidth};
    border-radius: 8px !important;
    font-size: ${({$fontSize}) => $fontSize || '14px'};
    height: ${({$height}) => $height || '30px'};
    line-height: ${({$lineHeight}) => $lineHeight};
    text-shadow: none;
    padding: 5px 10px 5px 7px;
    font-weight: normal;
    background-image: none;
    &:hover,
    &:active,
    &:focus,
    &:disabled {
        background-image: none;
        box-shadow: none;
    }
    &:disabled {
        cursor: not-allowed;
    }
    &.round {
        border-radius: calc(${({$height}) => $height || '30px'} / 2) !important;
        font-weight: bold;
        img {
            margin-top: 0;
        }
    }
`;

export const PrimaryButton = styled(BaseButton)`
    color: ${({theme}) => theme.colors.buttonText.main};
    border: none;
    background-color: ${({theme}) => theme.colors.secondary.main};
    &:hover {
        background-color: ${({theme}) => theme.colors.primary.main};
        color: white;
        border: none;
    }
    &:active,
    &:focus {
        border: none;
        background-color: ${({theme}) => theme.colors.secondary.main};
    }
    &:disabled {
        color: white;
        border: none;
        background-color: ${({theme}) => theme.colors.secondary.main};
        opacity: 0.6;
    }
`;

const SecondaryButton = styled(BaseButton)`
    color: #6b6f70;
    border: 1px solid #6b6f70;
    background-color: white;
    &:hover {
        background-color: #eee;
        color: #6b6f70;
    }
    &:active,
    &:focus {
        border: 1px solid #6b6f70;
        background-color: white;
    }
`;
interface ButtonElement {
    primary: JSX.Element;
    secondary: JSX.Element;
}
const Button = ({
    children,
    $width,
    $type = 'primary',
    ...rest
}: ButtonProps) => {
    const component: ButtonElement = {
        primary: (
            <PrimaryButton $width={$width} {...rest}>
                {children}
            </PrimaryButton>
        ),
        secondary: (
            <SecondaryButton $width={$width} {...rest}>
                {children}
            </SecondaryButton>
        ),
    };
    return $type in component ? component[$type as keyof ButtonElement] : null;
};

export default Button;
